import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '@core/services/auth.service';
import { catchError, from, switchMap, throwError } from 'rxjs';
import { environment } from '@environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  // Skip if it's not a protected endpoint
  if (!req.url.includes('/api/')) {
    return next(req);
  }

  const scopes = environment.azureAd.scopes;
  return from(authService.acquireToken(scopes)).pipe(
    switchMap((token) => {
      // Clone the request and add auth header
      const authReq = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${token}`),
      });
      // Forward the cloned request
      return next(authReq);
    }),
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
      }
      return throwError(() => error);
    }),
  );
};
